import Container from './container'
import Reducer from './reducer'

export {
  Reducer
}
export default Container


// WEBPACK FOOTER //
// ./src/registration/index.js